/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************!*\
  !*** ./src/js/countdown.js ***!
  \*****************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

if (customElements.get('countdown-timer') === undefined) {
  var CountdownTimer = /*#__PURE__*/function (_HTMLElement) {
    _inherits(CountdownTimer, _HTMLElement);

    var _super = _createSuper(CountdownTimer);

    function CountdownTimer() {
      _classCallCheck(this, CountdownTimer);

      return _super.call(this);
    }

    _createClass(CountdownTimer, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.label = document.querySelector('.countdown-label');
        this.days = this.querySelector('#countdown-days');
        this.hours = this.querySelector('#countdown-hours');
        this.mins = this.querySelector('#countdown-minutes');
        this.timezone = this.getAttribute('timezone');
        var datestring = new Date(this.getAttribute('endtime')).toLocaleString('en-US');
        this.date = new Date(datestring).getTime();

        if (this.date && !isNaN(this.date)) {
          if (this.hidden) this.removeAttribute('hidden');
          this.countdown = setInterval(function () {
            this.timer(this.date);
          }.bind(this), 1000);
        }
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {}
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name, oldVal, newVal) {}
    }, {
      key: "adoptedCallback",
      value: function adoptedCallback() {}
    }, {
      key: "timeunit",
      value: function timeunit(_int, noun) {
        var unit = _int != 1 ? "".concat(noun, "s") : "".concat(noun);
        return "".concat(_int, " ").concat(unit);
      }
    }, {
      key: "timer",
      value: function timer(date) {
        var datestring = new Date().toLocaleString('en-US', {
          timeZone: "".concat(this.timezone)
        });
        var now = new Date(datestring).getTime();
        var remaining = date - now;
        if (remaining < 0) this.end();
        var days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        var hours = Math.floor(remaining % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        var mins = Math.floor(remaining % (1000 * 60 * 60) / (1000 * 60));
        var secs = Math.floor(remaining % (1000 * 60) / 1000);

        if (days < 1) {
          this.days.setAttribute('hidden', '');
          this.mins.removeAttribute('hidden');
        }

        if (remaining >= 0) {
          this.days.innerText = "".concat(this.timeunit(days, 'Day'));
          this.hours.innerText = "".concat(this.timeunit(hours, 'Hour'));
          this.mins.innerText = "".concat(this.timeunit(mins, 'Minute'));
        }
      }
    }, {
      key: "end",
      value: function end() {
        this.label.innerText = this.label.getAttribute('complete');
        clearInterval(this.countdown);
        this.hidden = true;
      }
    }, {
      key: "hidden",
      get: function get() {
        return this.hasAttribute('hidden');
      },
      set: function set(val) {
        if (val) {
          this.setAttribute('hidden', '');
        } else {
          this.removeAttribute('hidden');
        }
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        return ['hidden'];
      }
    }]);

    return CountdownTimer;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  customElements.define('countdown-timer', CountdownTimer);
}
/******/ })()
;